const mongoose = require("mongoose");
const Schema = mongoose.Schema;

const warehouseSchema = new Schema(
    {
        Description: {
            type: String,
        },
        DescriptionRu: {
            type: String,
        },
        CityRef: {
            type: String,
            index: true, // Добавлен индекс для ускоренного поиска по городам
        },
        SettlementDescription: {
            type: String,
        },
    },
    { timestamps: true } // Метки времени для отслеживания создания и обновления документа
);

module.exports = mongoose.model("Warehouse", warehouseSchema);
